import { useEffect, useState } from "react";
import api, { errMsg } from "@/lib/api";
import { toast } from "sonner";
import { UserX } from "lucide-react";

const ROLE_LABEL = { parent: "Parent", vendor: "Vendor", event_creator: "Event Creator", marketplace_user: "Marketplace Seller" };

export default function DeletedAccountsTab() {
  const [rows, setRows] = useState(null);

  useEffect(() => {
    api.get("/admin/deleted-accounts")
      .then((r) => setRows(r.data))
      .catch((e) => { setRows([]); toast.error(errMsg(e, "Could not load deleted accounts")); });
  }, []);

  if (rows === null) return <p className="text-forest/60 text-sm" data-testid="deleted-accounts-loading">Loading…</p>;

  return (
    <div className="bg-white/80 border border-sage/20 rounded-3xl shadow-sm overflow-hidden" data-testid="deleted-accounts-tab">
      {rows.length === 0 ? (
        <div className="p-10 text-center text-forest/60" data-testid="deleted-accounts-empty">
          <UserX className="w-8 h-8 mx-auto mb-2 text-forest/30" />
          No deleted accounts yet.
        </div>
      ) : (
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="bg-softstone/50 text-forest/60 text-xs uppercase tracking-wide">
              <tr>
                <th className="text-left px-5 py-3">Email</th>
                <th className="text-left px-5 py-3">Role</th>
                <th className="text-left px-5 py-3">Date deleted</th>
                <th className="text-left px-5 py-3">Deleted by</th>
                <th className="text-left px-5 py-3">Reason</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((r) => <DeletedRow key={r.user_id} r={r} />)}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

function DeletedRow({ r }) {
  const byUser = r.deleted_by === "user";
  return (
    <tr className="border-t border-sage/10" data-testid={`deleted-row-${r.user_id}`}>
      <td className="px-5 py-3 font-semibold text-forest" data-testid={`deleted-email-${r.user_id}`}>{r.email || "—"}</td>
      <td className="px-5 py-3 text-forest/70">{ROLE_LABEL[r.role] || "—"}</td>
      <td className="px-5 py-3 text-forest/70" data-testid={`deleted-date-${r.user_id}`}>
        {r.deleted_at ? new Date(r.deleted_at).toLocaleString() : "—"}
      </td>
      <td className="px-5 py-3">
        <span
          className={`inline-block whitespace-nowrap text-[10px] font-bold uppercase px-2 py-1 rounded-full ${byUser ? "bg-amber-100 text-amber-800" : "bg-terracotta-light text-terracotta-dark"}`}
          data-testid={`deleted-by-${r.user_id}`}
        >
          {byUser ? "Deleted by user" : "Deleted by admin"}
        </span>
        {!byUser && r.admin_email && <span className="block text-[11px] text-forest/50 mt-1">{r.admin_email}</span>}
      </td>
      <td className="px-5 py-3 text-forest/70 max-w-xs" data-testid={`deleted-reason-${r.user_id}`}>{r.reason || "—"}</td>
    </tr>
  );
}
